export default {
  WidgetContainer: {
    display: "flex",
    maxWidth: "50%",
  },
};
